import angular from 'angular';
import { controller } from './app';

controller('MainController', [
  '$scope',
  'AlertMessenger',
  function($scope, AlertMessenger) {
    angular.element('.carousel').carousel();
    $scope.cdnPrefix = __CDN__;
  }
]);
